import { Injectable } from '@angular/core';
import { CacheContext, HttpService } from './http.service';
import { CustomDictionary } from '@weavix/models/src/custom-dictionary/custom-dictionary';

@Injectable({
    providedIn: 'root',
})
export class CustomDictionaryService {

    constructor(
        private readonly httpService: HttpService,
    ) { }

    static baseUrl = '/core/custom-dictionaries';
    static cacheCollection = 'custom-dictionaries';
    private readonly cacheContext: CacheContext = { collection: CustomDictionaryService.cacheCollection, maxAge: 1_800_000 };

    static url = (id?: string) => id ? `${CustomDictionaryService.baseUrl}/${id}` : CustomDictionaryService.baseUrl;

    getAll(component: any): Promise<CustomDictionary[]> {
        return this.httpService.get<CustomDictionary[]>(component, CustomDictionaryService.url(), { }, this.cacheContext);
    }

    get(component: any, id: string) {
        return this.httpService.get<CustomDictionary>(component, CustomDictionaryService.url(id), null, this.cacheContext);
    }

    save(component: any, customDictionary: Partial<CustomDictionary>) {
        return customDictionary.id
            ? this.update(component, customDictionary.id, customDictionary)
            : this.add(component, customDictionary);
    }

    private add(component: any, customDictionary: Partial<CustomDictionary>) {
        return this.httpService.post<CustomDictionary>(component, CustomDictionaryService.url(), customDictionary, this.cacheContext);
    }

    private update(component: any, id: string, customDictionary: Partial<CustomDictionary>) {
        return this.httpService.put<CustomDictionary>(component, CustomDictionaryService.url(id), customDictionary, this.cacheContext);
    }

    delete(component: any, id: string) {
        return this.httpService.delete<void>(component, CustomDictionaryService.url(id), null, this.cacheContext);
    }
}
